<template>
  <div class="w-full h-full flex flex-col bg-blue-star">
    <ElConfigProvider :size="state.size" :z-index="state.zIndex">
      <RouterView />
    </ElConfigProvider>
    <Popup />
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import Popup from "@/components/popups/Popup.vue";

const state = reactive({
  zIndex: 3000,
  size: "small",
});
</script>
